import { Directive, ElementRef, input, model, inject } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[coreTooltipDisplay]',
  providers: [NgbTooltip],
  standalone: true,
})
export class TooltipDisplayDirective {
  private tooltip = inject(NgbTooltip);
  private el = inject(ElementRef);

  tooltipText = model<string>('', { alias: 'coreTooltipDisplay' });
  displayDuration = input<number>(1500);

  constructor() {
    this.tooltip.placement = 'top';
    this.tooltip.container = 'body';
  }

  showTooltip() {
    this.tooltip.ngbTooltip = this.tooltipText();
    this.tooltip.open(this.el.nativeElement);
    setTimeout(() => this.tooltip.close(), this.displayDuration());
  }
}
